module.exports = __webpack_public_path__ + "assets/129ba989ce7966301d643d0e5461cf58.png";